$(document).ready(function () {
	'use strict';
	// navbar js start ---
	/* $(window).on('load scroll', function () {
		var scrolling = $(this).scrollTop();
		if (scrolling > 10) {
			$('.navbar').addClass('nav-fixed')
		} else {
			$('.navbar').removeClass('nav-fixed')
		}
	}) */

	$(".ham-menu").click(function (event) {
		event.stopPropagation();
		$(".navbar-inner-bottom").toggleClass("active");
		$(".ham-menu").toggleClass("active");
		$(".nav-link-wrapper").toggleClass("active");
		$("body").toggleClass("active");
	});

	$(".mobile-menu-close-window-btn").click(function (event) {
		event.stopPropagation();
		$(".navbar-inner-bottom").toggleClass("active");
		$(".ham-menu").toggleClass("active");
		$(".nav-link-wrapper").toggleClass("active");
		$("body").toggleClass("active");
	});
	// navbar js end ---

	// collection-filter js start---
  
	/* $(".filter-open-btn").click(function (event) {
		event.stopPropagation();
		$(".collection-filter").addClass("active");
		$("body").addClass("active");
	});

	$(".filter-close-btn").click(function (event) {
		event.stopPropagation();
		$(".collection-filter").removeClass("active");
		$("body").removeClass("active");
	}); */
  
	// collection-filter js end---

	// collection tab js start---
  
	/* $('.collection-tab-link').click(function () {
		$('.collection-tab-link').removeClass('active');
		$(this).addClass('active');
		$('.tab-content-item').hide();

		var activeTab = $(this).attr('href');
		$(activeTab).fadeIn();
		return false;
	});


	$(".qty-increase").click(function () {
		$(".quantity-total").val(parseInt($(".quantity-total").val()) + 1);
	});

	$(".qty-decrease").click(function () {
		var currentValue = parseInt($(".quantity-total").val());
		if (currentValue > 1) {
			$(".quantity-total").val(currentValue - 1);
		}
	}); */

	// collection tab js end---

	// **..product-accordion js start..**
  
	/* $('.product-accordion-toggle-btn').on('click', function () {
		$(this).next().slideToggle();
		$(this).parent().toggleClass('active');
		$(this).parent().siblings().removeClass('active').find('.product-accordion-item-content').slideUp();
	}); */
  
	// **..product-accordion js end..**

	// mobile-dropdown responsive accordion js start--
	$(function () {
		let isMobile = window.matchMedia("only screen and (max-width: 992px)").matches;

		if (isMobile) {
			// **..mobile-dropdown-accordion js start..**
			$('.dropdown-btn').on('click', function () {
				$(this).next(".dropdown-menu").slideToggle();
				$(this).toggleClass('active');
			});

			$('.sub-dropdown-btn').on('click', function () {
				$(this).next(".sub-dropdown-menu").slideToggle();
				$(this).toggleClass('active');
			});
			// **..mobile-dropdown-accordion js end..**
		}
	});
	// mobile-dropdown responsive accordion js end--

	
	$(".option_input").on('change', function () {
		var name = $(this).data('name');
		$('.selected_option').text(name);
	});

	$(".item-title").on('click', function () {
		$(this).next().toggleClass('show');
		$(this).parent().siblings().find('.filter-options-wrapper').removeClass('show');
	});

	$(document).on('click', function (e) {
		if (!$(e.target).closest('.collection-filter-item').length) {
		  $('.filter-options-wrapper').removeClass('show');
		}
	  });

	// Function to get combined selected option values
	function getSelectedOptions() {
		let optionName = '';

		// Get selected value from select
		let selectVal = $('.option_select').val();
		if (selectVal) {
			optionName += selectVal;
		}

		// Get selected values from radio inputs
		$('input:radio.option_input:checked').each(function () {
			optionName += optionName !== '' ? '-' : '';
			optionName += $(this).val();
		});

		return optionName;
	}

	// Change image / availability when product options change
	$('.option_input, .option_select').on('change', function () {
		let optionName = getSelectedOptions();

		// Find the matching variant
		$('#productSelect option').each(function () {
			var txt = $.trim($(this).text());
			if (txt === optionName) {
				var id = $(this).val();
				$('#productSelect').val(id);
				var available = $(this).data('available');

				const url = new URL(window.location.href);
				url.searchParams.set('variant', id);
				window.history.replaceState(null, null, url);

				if (available) {
					$('.atc_text').removeClass('sold_out').text('Ajouter au panier');
				} else {
					$('.atc_text').addClass('sold_out').text('Épuisé');
				}
			}
		});
	});


})
